__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-08-24-1787579748-stable-dev/";